export default {
  NEW: 'new',
  EMPTY: 'empty',
  ALL: 'all',
};
